// useTranscript.ts
import { useRef, useMemo, useEffect } from 'react';
import { TRANSCRIPT_ELEMENT } from '../../components/notes/consts';
import { useDebounceScrollEvent } from './use_debounce_scroll_event';
import MiniSearch from 'minisearch';
import { filterTranscriptionBlocksBySearchResults } from '../../util/transcript_utils';
export const useTranscriptContainer = ({ transcriptBlocks, selectedItemIndex, searchValue, recordScrollEvent, updateAutoScrollMode, roomSid, }) => {
    const scrollRef = useRef(null);
    const miniSearch = useRef(new MiniSearch({
        fields: ['text'],
        storeFields: ['text'],
        searchOptions: {
            prefix: true,
            fuzzy: 0.2, // enable fuzzy search at initialization
        },
    }));
    useEffect(() => {
        miniSearch.current.removeAll();
        miniSearch.current.addAll(transcriptBlocks);
    }, [transcriptBlocks]);
    const transcriptionBlockSearchResults = useMemo(() => {
        if (!searchValue || searchValue.trim() === '') {
            return {
                filteredBlocks: transcriptBlocks,
                matchingSearchTerms: [],
            };
        }
        const searchResults = miniSearch.current.search(searchValue);
        return filterTranscriptionBlocksBySearchResults(searchResults, transcriptBlocks);
    }, [transcriptBlocks, searchValue, miniSearch]);
    const selectedBlock = useMemo(() => (selectedItemIndex !== undefined ? transcriptBlocks[selectedItemIndex] : null), [transcriptBlocks, selectedItemIndex]);
    useDebounceScrollEvent({
        scrollRef,
        onScroll: () => {
            updateAutoScrollMode(false);
            recordScrollEvent(TRANSCRIPT_ELEMENT, roomSid);
        },
    });
    return useMemo(() => ({
        filteredBlocks: transcriptionBlockSearchResults.filteredBlocks,
        selectedBlock,
        scrollRef,
        matchingSearchTerms: transcriptionBlockSearchResults.matchingSearchTerms,
    }), [transcriptionBlockSearchResults, selectedBlock]);
};
//# sourceMappingURL=use_transcript_container.js.map